import React, { FC } from 'react'

import { IconDealsProps } from './IconDeals.types'
import * as Styled from './styles/IconDeals.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDeals: FC<IconDealsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDealsProps['size'],
  isResponsive = false,
}: IconDealsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m34.407 27.305 4.286 2.475a2.472 2.472 0 0 1 .904 3.38v0a2.471 2.471 0 0 1-3.38.905L25.5 27.88'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M34.072 32.828a2.478 2.478 0 0 1-.597 4.534c-.634.17-1.31.081-1.878-.247l-8.572-4.95'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.457 35.877a2.473 2.473 0 0 1 .905 3.373v0a2.474 2.474 0 0 1-3.38.905l-.287-.165-16.572-9.563-.286-.162A9.9 9.9 0 0 1 6.215 16.75l2.475-4.285A9.897 9.897 0 0 1 22.21 8.84l.863.5m4.9 14.255L38.7 29.783a2.475 2.475 0 0 0 3.38-.905v0a2.474 2.474 0 0 0-.905-3.378'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M41.477 24.957a9.858 9.858 0 0 0 1.318-4.524c.15-3.563.07-12.928.07-12.928s-12.783.07-14.57.132a9.893 9.893 0 0 0-8.25 4.946l-6.5 10.824a.25.25 0 0 0 .125.363l1.5.56a3.035 3.035 0 0 0 3.127-.615l4.265-4.64c2.938 1.25 4.953.44 6.608-.5l12 6.92.307-.538Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDeals
